module.exports = __webpack_public_path__ + "static/img/yd-banner0.098c5ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yd-banner0.png
// module id = 1BjQ
// module chunks = 0